import React, { useContext } from 'react';
import { CustomersContext, ICustomersContext } from '../../../customersState/customersContext';
import { EntityStatus } from 'types';
import breadcrumbs from 'images/breadcrumbs.svg';
import Button from 'components/Button/Button';
import Text from 'components/Text/Text';
import classNames from 'classnames';
import style from './ResetBtn.module.scss';

const ResetBtn: React.FC = () => {
	const { resetSelectedControls, searchString, status, selectedClientType } =
		useContext<ICustomersContext>(CustomersContext);

	const resetBtnClasses = classNames(style.resetBtn, {
		[style.active]: searchString || selectedClientType || status !== EntityStatus.Active,
	});

	return (
		<Button
			className={resetBtnClasses}
			theme="secondary"
			onClick={resetSelectedControls}
			icon={
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#resetIcon`} />
				</svg>
			}
			data-test="ResetBtn">
			<Text translationNameSpace="listing" translationKey="resetButton" asFragment={true} />
		</Button>
	);
};

export default ResetBtn;
